// auth
export const TOGGLE_SYSTEM_LOADING = "TOGGLE_SYSTEM_LOADING";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const UPDATE_MENU_LIST = "UPDATE_MENU_LIST";

// supplier
export const SUPPLIER_UPDATE_STATE = "SUPPLIER_UPDATE_STATE";
export const SUPPLIER_RESET_STATE = "SUPPLIER_RESET_STATE";

// apparatus
export const APPARATUS_UPDATE_STATE = "APPARATUS_UPDATE_STATE";

// user
export const USER_UPDATE_STATE = "USER_UPDATE_STATE";

// order
export const ORDER_UPDATE_STATE = "ORDER_UPDATE_STATE";
export const ORDER_UPDATE_EDIT_STATE = "ORDER_UPDATE_EDIT_STATE";
export const CLEAN_ORDER_DETAIL = "CLEAN_ORDER_DETAIL";

// department
export const DEPARTMENT_UPDATE_STATE = "DEPARTMENT_UPDATE_STATE";

// applicationrecord
export const APPLICATIONRECORD_UPDATE_STATE = "APPLICATIONRECORD_UPDATE_STATE";
export const APPLICATIONRECORD_UPDATE_EDIT_STATE =
  "APPLICATIONRECORD_UPDATE_EDIT_STATE";
export const CLEAN_APPLICATIONRECORD_DETAIL = "CLEAN_APPLICATIONRECORD_DETAIL";

// settlement
export const SETTLEMENT_UPDATE_STATE = "SETTLEMENT_UPDATE_STATE";

// scriptLibrary

export const SCRIPTLIBRARY_UPDATE_STATE = "SCRIPTLIBRARY_UPDATE_STATE";

// Sample

export const SAMPLE_UPDATE_STATE = "SAMPLE_UPDATE_STATE";
export const SAMPLELIST_UPDATE_STATE = "SAMPLELIST_UPDATE_STATE";
export const SAMPLE_RESET_STATE = "SAMPLE_RESET_STATE";

// email
export const EMAIL_UPDATE_STATE = "EMAIL_UPDATE_STATE";

export const SCORE_UPDATE_STATE = "SCORE_UPDATE_STATE";

export const SCORE_CONFIG_UPDATE_STATE = "SCORE_CONFIG_UPDATE_STATE";
export const SCORE_CONFIG_UPDATE_EDIT_STATE = "SCORE_CONFIG_UPDATE_EDIT_STATE";
export const CLEAN_SCORE_CONFIG_DETAIL = "CLEAN_SCORE_CONFIG_DETAIL";

export const SHOPLIST_UPDATE_STATE = "SHOPLIST_UPDATE_STATE";
export const SHOPLIST_RESET_STATE = "SHOPLIST_RESET_STATE";

export const SCORE_DEPLOY_UPDATE_STATE = "SCORE_DEPLOY_UPDATE_STATE";

export const RAIDSYS_UPDATE_STATE = "RAIDSYS_UPDATE_STATE";

export const MINE_UPDATE_STATE = "MINE_UPDATE_STATE";
export const MINE_RESET_STATE = "MINE_RESET_STATE";

export const CHECKLIST_UPDATE_STATE = "CHECKLIST_UPDATE_STATE";

export const USER_GROUP_UPDATE_STATE = "USER_GROUP_UPDATE_STATE";

export const GROUP_DETAIL_UPDATE_STATE = "GROUP_DETAIL_UPDATE_STATE";
